// Components==============
import indexPhase from 'actions/phase/index';
import { useRedux } from 'hooks/useRedux';
import { useReduxAction } from 'hooks/useReduxAction';
import React, { useContext, useEffect } from 'react';
import { FilterType } from 'typings';
import { FilterContext } from '../../FilterMenu';
import './Process.module.scss';
// =========================

export default function Process({
  value,
  id,
}: {
  value: number[];
  id: number;
}) {
  const { setFilterValues, filterValues } = useContext(FilterContext);

  const dispatch = useReduxAction();

  useEffect(() => {
    dispatch(indexPhase());
  }, []);

  const steps = useRedux((state) =>
    state.phase?.entities.allIds.map(
      (phaseId) => state.phase?.entities.byId[phaseId]
    )
  )?.slice(0, 5);

  function handleClick(step: number) {
    const filterValue = filterValues.find((e) => e.id === id)
      ?.value as number[];

    let newValue: number[] = [];

    if (filterValue.includes(step))
      newValue = filterValue.filter((val) => val !== step);
    else newValue = [...filterValue, step];

    setFilterValues(
      (prev) =>
        prev.map((prevVal) =>
          prevVal.id === id ? { ...prevVal, value: newValue } : prevVal
        ) as FilterType[]
    );
  }

  return (
    <div styleName="wrapper">
      {steps?.map((step) =>
        step ? (
          <div
            styleName={`step ${step?.slug} ${
              value.includes(step?.id) ? 'active' : ''
            }`}
            key={step?.name}
            onClick={() => handleClick(step?.id)}
          >
            {step?.name}
          </div>
        ) : null
      )}
    </div>
  );
}
